const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function pad2(n) {
  return String(n).padStart(2, '0');
}

export function isoToRu(iso) {
  const m = ISO_DATE_RE.exec(String(iso || ''));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '—';
}

export function unixToRu(seconds) {
  const n = Number(seconds);
  if (!Number.isFinite(n) || n <= 0) return '—';
  const d = new Date(n * 1000);
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}, ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function todayIso(date = new Date()) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function isOverdue(deadlineIso, today = todayIso()) {
  const value = String(deadlineIso || '');
  return ISO_DATE_RE.test(value) && value < today;
}

/* ---------- money (lifted from catalogPayload.js, KOP-39 spec §5.2) ---------- */

const THIN = '\u202F'; // narrow no-break space: thousands separator
const NBSP = '\u00A0';

/** Parses a decimal string or number; null for empty / non-numeric. */
export function toNumber(v) {
  if (v === null || v === undefined) return null;
  if (typeof v === 'string' && v.trim() === '') return null;
  const n = typeof v === 'number' ? v : Number(String(v).trim());
  return Number.isFinite(n) ? n : null;
}

/** Sign, grouped integer part and the two-digit fraction of a rounded amount. */
function moneyParts(n) {
  const rounded = Math.round(Math.abs(n) * 100);
  const intStr = String(Math.floor(rounded / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, THIN);
  return { sign: n < 0 && rounded > 0 ? '-' : '', intStr, frac: rounded % 100 };
}

/** `12 345,67 ₽`; the fraction is omitted when zero; '—' for non-numbers. */
export function formatRub(n) {
  const v = toNumber(n);
  if (v === null) return '—';
  const { sign, intStr, frac } = moneyParts(v);
  const fracStr = frac ? `,${String(frac).padStart(2, '0')}` : '';
  return `${sign}${intStr}${fracStr}${NBSP}₽`;
}

/** Like formatRub but always two decimals (table cells). */
export function formatRubCell(n) {
  const v = toNumber(n);
  if (v === null) return '—';
  const { sign, intStr, frac } = moneyParts(v);
  return `${sign}${intStr},${String(frac).padStart(2, '0')}${NBSP}₽`;
}

/** Russian plural: pluralRu(5, ['пачка', 'пачки', 'пачек']) → 'пачек'. Non-finite or negative → the "many" form. */
export function pluralRu(n, [one, few, many]) {
  const v = Math.abs(Math.trunc(Number(n)));
  if (!Number.isFinite(v)) return many;
  const mod10 = v % 10;
  const mod100 = v % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
